// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  padding: 12px;
  margin: 0;
  justify-content: space-between;
}

.defined_price {
  font-size: 16px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 5px;
  font-weight: bold;
  color: rgb(186, 165, 153);
  border-left: 4px dashed #fff3e7;
  border-right: 4px dashed #fff3e7;
  white-space: nowrap;
}
.defined_price label {
  font-size: 10px;
}

.shipped_txt {
  font-size: 12px;
  margin: 0;
}

.discount_price {
  font-size: 10px;
  color: #e9b3a3;
  text-decoration: line-through;
  display: block;
  margin-top: 2px;
}

.shipping_price {
  font-size: 10px;
  color: #d2c1b7;
  display: block;
}

.btnn {
  font-size: 11px;
  text-align: left;
  border-radius: 3px;
  font-weight: 800;
  white-space: nowrap;
  padding: 0 12px;
  color: #bba599;
  --color: #bba599;
  background: none;
  border: 1px solid #bba599;
}

.filled_btnn {
  background: #bba599;
  color: #fff3e7;
  --color: #fff3e7;
}

.addbag_btn {
  font-size: 14px;
}

.red_defined_price {
  color: #db7878;
}

@media only screen and (max-width: 375px) {
  .only_big {
    display: none !important;
  }
  .only_small {
    display: block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/listing-footer/listing-footer.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,SAAA;EAEA,8BAAA;AAAJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mBAAA;AAAJ;AAEI;EACI,eAAA;AAAR;;AAIA;EACI,eAAA;EACA,SAAA;AADJ;;AAIA;EACI,eAAA;EACA,cAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,eAAA;EACA,cAAA;EACA,cAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EAEA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI;IACI,wBAAA;EAFN;EAKE;IACI,yBAAA;EAHN;AACF","sourcesContent":["ion-toolbar {\n    padding: 12px;\n    margin: 0;\n\n    justify-content: space-between;\n}\n\n.defined_price {\n    font-size: 16px;\n    margin-left: 5px;\n    margin-right: 5px;\n    border-radius: 5px;\n    font-weight: bold;\n    color: rgb(186, 165, 153);\n    border-left: 4px dashed #fff3e7;\n    border-right: 4px dashed #fff3e7;\n    white-space: nowrap;\n\n    label {\n        font-size: 10px;\n    }\n}\n\n.shipped_txt {\n    font-size: 12px;\n    margin: 0;\n}\n\n.discount_price {\n    font-size: 10px;\n    color: #e9b3a3;\n    text-decoration: line-through;\n    display: block;\n    margin-top: 2px;\n}\n\n.shipping_price {\n    font-size: 10px;\n    color: #d2c1b7;\n    display: block;\n}\n\n.btnn {\n    font-size: 11px;\n    text-align: left;\n    border-radius: 3px;\n    font-weight: 800;\n    white-space: nowrap;\n    padding: 0 12px;\n\n    color: #bba599;\n    --color: #bba599;\n    background: none;\n    border: 1px solid #bba599;\n}\n\n.filled_btnn {\n    background: #bba599;\n    color: #fff3e7;\n    --color: #fff3e7;\n}\n\n.addbag_btn {\n    font-size: 14px;\n}\n\n.red_defined_price {\n    color: #db7878;\n}\n\n@media only screen and (max-width: 375px) {\n    .only_big {\n        display: none !important;\n    }\n\n    .only_small {\n        display: block !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
